/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage, useIntl} from 'react-intl'
// Components
import {Box,
    Text,
    Flex,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

// Project Components
import Breadcrumb from '../../../components/breadcrumb'
import Seo from '../../../components/seo'

const PageHeader = ({
    category,
    productSearchResult,
    searchQuery,
    ...otherProps
}) => {
    const {formatMessage} = useIntl()
    const stylePlpSrp = useMultiStyleConfig('PlpSrpPages')

    const searchResultsPageTitle = formatMessage({
        id: 'search.results.page.title',
        defaultMessage: 'Search | Garage Clothing'
    })

    return (
        <Box {...otherProps} data-testid="sf-product-list-breadcrumb">
            {searchQuery && <Seo title={searchResultsPageTitle} />}
            {/* Breadcrumb */}
            <Breadcrumb categories={category?.parentCategoryTree} />

            {/* Category / search title */}
            {searchQuery &&
                <Flex {...stylePlpSrp.headingContainer}>
                    <Flex gap={4} flexWrap="wrap">
                        <Text as="h1" {...stylePlpSrp.srpTitle}>
                            <FormattedMessage
                                defaultMessage="Search results"
                                id="search.result.heading"
                            />
                        </Text>
                    </Flex>

                    {productSearchResult?.total > 0 && (
                        <Text {...stylePlpSrp.srpSubtitle}>
                            {productSearchResult?.total > 0 ? (
                                <FormattedMessage
                                    defaultMessage='Showing {total} items for "{searchQuery}"'
                                    values={{total: productSearchResult?.total, searchQuery}}
                                    id="search_page.text.items"
                                />
                            ) : (
                                <FormattedMessage
                                    defaultMessage="Sorry! No items found. But here are some recommendations for you."
                                    id="search_page.text.no_items"
                                />
                            )}
                        </Text>
                    )}
                </Flex>
            }
        </Box>
    )
}

PageHeader.propTypes = {
    category: PropTypes.object,
    productSearchResult: PropTypes.object,
    searchQuery: PropTypes.string,
    total: PropTypes.number
}

export default PageHeader
